import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Home() {
  // const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate()

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
      }
    } else {
      window.scrollTo(0, 0)
    }

  }, [location]);


  return (
    <div className="new_home_page" >
      <section
        id="home"
        className="position-relative d-flex align-items-center justify-content-center text-center text-white"
        style={{
          backgroundImage: "url('assets/images/hero-bg-2.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          // minHeight: "850px",
        }}
      >
        <div className="container_new ">

          {/* Floating Image */}
          <div
            className="position-absolute z-0 mt-5 ms-n5 d-lg-block wow animate__animated animate__fadeInLeft"
            data-wow-duration="1.2s"
            style={{ top: "3.5rem", left: '-7rem' }}
          >
            <img src="assets/images/Paybacck-p.png" alt="Paybacck" />
          </div>

          {/* Content */}
          <div
            className="content_new mx-auto text-center"
            style={{ maxWidth: "760px" }}
          >
            <h1
              className="heading_new wow animate__animated animate__fadeInUp"
              style={{ letterSpacing: "-1.25px", fontWeight: '700', }}
              data-wow-delay="0.2s"
            >
              Stop Wasting Millions on Failed Tech Investments.
            </h1>

            <p
              className="sm_cont wow animate__animated animate__fadeInUp"
              data-wow-delay="0.4s"
              style={{ fontSize: 18, paddingTop: 18, lineHeight: '28px', color: "rgba(255 255 255  0.8)" }}
            >
              Paybacck is the only research-driven platform that tells you whether a
              technology initiative is worth pursuing—before you commit time, budget,
              and resources.
            </p>

            {/* Buttons */}
            <div
              className="new_section_button wow animate__animated animate__fadeInUp d-flex flex-column flex-sm-row justify-content-center"
              data-wow-delay="0.6s"
            >
              <button
                className="primary-button  text-uppercase d-flex align-items-center justify-content-center gap-2"
              // style={{ fontSize: "14px" }}
              onClick={()=>navigate('/sign')}

              >
                Start Free Trial
                <span>
                  <img src="assets/icons/long-arrow-right.svg" alt="" />
                </span>
              </button>

              <button
                className="secondary-button"
                style={{ fontSize: "14px", padding: '13px 32px' }}
              onClick={()=>navigate('#work')}
              >
                See How It Works
              </button>
            </div>
          </div>

          {/* Hero Image */}
          <div
            className="hero_image wow animate__animated animate__fadeInUp mx-auto"
            style={{ maxWidth: "950px" }}
            data-wow-delay="0.6s"
          >
            <img
              src="assets/images/hero-man.png"
              alt="hero man"
              className="img-fluid"
            />
          </div>
        </div>
      </section>

      <section id="about-us" className="about_us_new" >
        <div className="container_new px-4">
          <h6
            className="about_us_trusted  wow animate__animated animate__fadeInDown text-black text-uppercase text-center fw-medium"
            style={{ fontSize: "20px" }}
            data-wow-duration="1s"
          >
            Trusted Framework, Proven Results.
          </h6>

          <div className="about_us_outer  d-flex justify-content-between align-items-center" style={{ flexWrap: 'nowrap', gap: 35 }}>

            {/* Stats */}
            {/* <div className=""> */}
            <div
              className="about_us_boxes"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'nowrap',
                padding: "35px 0px",
                gap: 10,
                flex: 2
                // flex items-center gap-[34px] justify-between flex-wrap md:flex-nowrap pt-[25px] lg:pt-[35px]
              }}

            >

              {/* <div className="col-md-4"> */}
              <div
                className="wow animate__animated animate__fadeInUp bg-white shadow-card"
                data-wow-delay="0.1s"
                style={{ padding: 24, width: '100%' }}
              >
                <h6 className="about-us-box"  >6+</h6>
                <p className='' style={{ paddingTop: '20px', lineHeight: '21px', color: "rgb(110 110 110)", fontWeight: '500' }}>
                  Years of research behind every assessment.
                </p>
              </div>
              {/* </div> */}

              {/* <div className="col-md-4"> */}
              <div
                className="wow animate__animated animate__fadeInUp bg-white shadow-card"
                style={{ padding: 24, width: '100%' }}
                data-wow-delay="0.3s"
              >
                <h6 className=" about-us-box " >12–25%</h6>
                <p className='' style={{ paddingTop: '20px', lineHeight: '21px', color: "rgb(110 110 110)", fontWeight: '500' }}>
                  Reduction in IT costs for enterprises.
                </p>
              </div>
              {/* </div> */}

              {/* <div className="col-md-4"> */}
              <div
                className="wow animate__animated animate__fadeInUp bg-white shadow-card"
                style={{ padding: 24, width: '100%' }}

                data-wow-delay="0.5s"
              >
                <h6 className="about-us-box "  >$100M+</h6>
                <p className='' style={{ paddingTop: '20px', lineHeight: '21px', color: "rgb(110 110 110)", fontWeight: '500' }}>
                  Millions saved by avoiding failed initiatives.
                </p>
              </div>
              {/* </div> */}

            </div>
            {/* </div> */}

            {/* Logos */}
            <div className="about_us_logos d-flex align-items-center gap-3 justify-content-between"
              style={{ flex: 1.1 }}
            >

              <div
                className="wow animate__animated animate__zoomIn"
                data-wow-delay="0.2s"
              >
                <img
                  src="assets/icons/Fictional company logo.svg"
                  alt="Fictional company"
                  style={{ width: "130px" }}
                />
              </div>

              <div
                className="wow animate__animated animate__zoomIn"
                data-wow-delay="0.4s"
              >
                <img
                  src="assets/icons/Fictional company logo (1).svg"
                  alt="Fictional company"
                  style={{ width: "130px" }}
                />
              </div>

              <div
                className="wow animate__animated animate__zoomIn"
                data-wow-delay="0.6s"
              >
                <img
                  src="assets/icons/Fictional company logo (2).svg"
                  alt="Fictional company"
                  style={{ width: "130px" }}
                />
              </div>

            </div>

          </div>
        </div>
      </section>


      {/* <!-- Problem + Value Proposition --> */}
      <section id="ValueProposition" className="section_new_outer_container ValueProposition_sec container_new px-4 "
      //  style={{ maxWidth: 1260, margin: 'auto', width: '100%' }} 
      >
        <div className="section_new_container d-flex align-items-center flex-column-reverse flex-lg-row"
        >
          {/* Image */}
          <div
            className="ValueProposition_new_image  wow animate__animated animate__fadeInUp"
            data-wow-duration="1.2s"
            // style={{ width: '49%' }}
            style={{ display: 'flex', justifyContent: 'center' }}

          >
            <img
              src="assets/images/ValueProposition.png"
              alt="Value Proposition"
              className="img-fluid"
            />
          </div>

          {/* Content */}
          <div
            className="ValueProposition_new_content  wow animate__animated animate__fadeIn"
            data-wow-duration="1.2s"
          >
            <p
              className="tag w-fit  wow animate__animated animate__fadeInDown"
              data-wow-delay="0.1s"
            >
              Problem + Value Proposition
            </p>

            <h2
              className="section-header  wow animate__animated animate__fadeInUp"
              data-wow-delay="0.2s"
            >
              70% of digital initiatives fail to deliver promised value. Enterprises
              waste billions chasing ideas without clarity.
            </h2>

            <p
              className="section-description wow animate__animated animate__fadeInUp"
              data-wow-delay="0.4s"
            >
              We give leaders a data-backed, systematic way to assess opportunities,
              align stakeholders, and pivot with confidence.
            </p>

            {/* Bullet Points */}
            <div className="mb-4">
              {[
                "Evaluate initiatives in minutes, not months.",
                "Uncover high-ROI opportunities and avoid costly mistakes.",
                "Secure executive and stakeholder buy-in with transparent scores.",
                "Build products customers actually adopt.",
              ].map((text, index) => (
                <div
                  key={index}
                  className="wow animate__animated animate__fadeInUp d-flex align-items-center gap-3 right-text"
                  data-wow-delay={`${0.5 + index * 0.1}s`}
                >
                  <span>
                    <img
                      src="assets/icons/green-right.svg"
                      alt="check icon"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </span>
                  <span className="descripp" >{text}</span>
                </div>
              ))}
            </div>

            {/* Buttons */}
            {/* <div
              className="new_section_button wow animate__animated animate__fadeInUp d-flex flex-column flex-sm-row"
              data-wow-delay="1s"
            >
              <button className="primary-button py-4  w-sm-auto text-uppercase">
                Learn more
              </button>
              <button className="secondary-button-2  py-4 w-sm-auto text-uppercase">
                Product tour
              </button>
            </div> */}
          </div>

        </div>
      </section>


      {/* <!--End Problem + Value Proposition --> */}


      {/* <!-- How Paybacck Helps --> */}
      <section id="PaybacckHelps" className="section_new_outer_container container_new px-4 ">
        {/* <div className="container_new px-4"> */}
        <div className=" section_new_container d-flex align-items-center flex-lg-row"
        // style={{ columnGap: 75 }}
        >

          {/* Content */}
          <div
            className="PaybacckHelps_new_content order-2 order-lg-1 wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-offset="120"
          >
            <p
              className="tag w-fit  wow animate__animated animate__fadeIn"
              data-wow-delay="0.1s"
            >
              How Paybacck Helps
            </p>

            <h2
              className="section-header wow animate__animated animate__fadeInUp"
              data-wow-delay="0.2s"
            >
              Turn Tech Uncertainty Into Business Growth.
            </h2>

            <p
              className="section-description wow animate__animated animate__fadeInUp"
              data-wow-delay="0.3s"
            >
              70% of all technology initiatives fail to deliver business value, and
              31% are canceled before completion, costing companies ~US $150 billion
              a year.
            </p>

            {/* Benefits */}
            <div className="mb-4">
              {[
                "Save Millions: Prevent wasted spend with early no-go calls.",
                "Accelerate Decisions: Move from idea to validation in days.",
                "Boost Alignment: Common framework builds trust across IT, product, and business teams.",
                "Drive Growth: Identify products and innovations that scale.",
                "Reduce Risk: Built-in risk analysis reduces failed launches.",
              ].map((text, index) => (
                <div
                  key={index}
                  className="wow animate__animated animate__fadeInUp d-flex align-items-center gap-3 right-text"
                  data-wow-delay={`${0.4 + index * 0.1}s`}
                >
                  <span>
                    <img
                      src="assets/icons/green-right.svg"
                      alt="check icon"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </span>
                  <span className="descripp">{text}</span>
                </div>
              ))}
            </div>

            {/* Buttons */}
            {/* <div
              className="new_section_button wow animate__animated animate__fadeInUp d-flex flex-column flex-sm-row"
              data-wow-delay="0.9s"
            >
              <button className="primary-button py-4 w-sm-auto text-uppercase">
                Learn more
              </button>
              <button className="secondary-button-2 py-4 w-sm-auto text-uppercase">
                Product tour
              </button>
            </div> */}
          </div>

          {/* Images */}
          <div
            className="PaybacckHelps_new_image position-relative order-1 order-lg-2 wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-offset="120"
            style={{ display: 'flex', justifyContent: 'center' }}

          >
            <img
              src="assets/images/investment.png"
              alt="investment"
              className="position-absolute  d-none d-lg-block wow animate__animated animate__fadeInUp"
              data-wow-delay="0.5s"
              style={{ left: "-3rem", bottom: "8rem" }}
            />

            <img
              src="assets/images/PaybacckHelps.png"
              alt="Paybacck Helps"
              className="img-fluid wow animate__animated animate__fadeInUp"
              data-wow-delay="0.3s"
            />
          </div>

        </div>
        {/* </div> */}
      </section>


      {/* <!--End How Paybacck Helps --> */}

      {/* <!-- Features & Platform Pillars --> */}
      <section id="PlatformPillars" className="section_new_outer_container container_new px-4 ">
        {/* <div className="container_new px-4"> */}
        <div className="section_new_container d-flex align-items-center flex-column-reverse flex-lg-row"
        >
          {/* Image */}
          <div
            className="PlatformPillars_new_image wow animate__animated animate__fadeIn"
            data-wow-duration="1.2s"
            style={{ display: 'flex', justifyContent: 'center' }}

          >
            <img
              src="assets/images/PlatformPillars.png"
              alt="Platform Pillars"
              className="img-fluid"
            />
          </div>

          {/* Content */}
          <div
            className="PlatformPillars_new_content wow animate__animated animate__fadeIn"
            data-wow-duration="1.2s"
          >
            <p
              className="tag w-fit  wow animate__animated animate__fadeInDown"
              data-wow-delay="0.1s"
            >
              Features &amp; Platform Pillars
            </p>

            <h2
              className="section-header wow animate__animated animate__fadeInUp"
              data-wow-delay="0.2s"
            >
              Everything You Need to Invest With Precision.
            </h2>

            <p
              className="section-description wow animate__animated animate__fadeInUp"
              data-wow-delay="0.4s"
              style={{ maxWidth: "66%" }}
            >
              A suite of 16 research-led assessment &amp; pivot tools &amp; online
              scorecards provide the critical answers you seek.
            </p>

            {/* Feature List */}
            <div className="mb-4">
              {[
                "Precision Invest Suite: 16 assessment and pivot tools with online scorecards.",
                "Opportunity, Execution, Product Scoring: Quickly measure potential, readiness, and fit.",
                "Effort & Cost Estimation: Get realistic budgets and timelines upfront.",
                "Portfolio View: Compare initiatives, prioritize, and allocate resources with confidence.",
                "Training & Consulting: Upskill teams and scale enterprise adoption seamlessly.",
              ].map((text, index) => (
                <div
                  key={index}
                  className="wow descripp animate__animated animate__fadeInUp d-flex align-items-center gap-3 right-text"
                  data-wow-delay={`${0.5 + index * 0.1}s`}
                >
                  <span>
                    <img
                      src="assets/icons/green-right.svg"
                      alt="check icon"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </span>
                  <span>{text}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div
              className="new_section_button wow animate__animated animate__fadeInUp d-flex flex-column flex-sm-row"
              data-wow-delay="1.1s"
            >
              <button
              onClick={()=>navigate('/home#features')}
              className="primary-button py-4 w-sm-auto text-uppercase">
                Explore the Tools
              </button>
            </div>
          </div>

        </div>
        {/* </div> */}
      </section>

      {/* <!-- End Features & Platform Pillars --> */}


      {/* <!-- Who It’s For --> */}
      <section id="WhoFors" className="section_new_outer_container container_new px-4 ">
        {/* <div className=""> */}
        <div className="section_new_container d-flex align-items-center flex-column flex-lg-row"
        // style={{ gap: 75 }}
        >
          {/* Content */}
          <div
            className="WhoFors_new_content wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.1s"
          >
            <p
              className="tag w-fit wow animate__animated animate__fadeInDown"
              data-wow-delay="0.2s"
            >
              Who It’s For
            </p>

            <h2
              className="section-header wow animate__animated animate__fadeInUp"
              data-wow-delay="0.3s"
            >
              Designed for Leaders Who Can’t Afford Guesswork.
            </h2>

            <p
              className="section-description wow animate__animated animate__fadeInUp"
              data-wow-delay="0.4s"
              style={{ maxWidth: "66%" }}
            >
              CIOs &amp; CTOs
            </p>

            {/* Audience List */}
            <div className="mb-4">
              {[
                "Enterprise & Mid-Market Product Leaders",
                "Innovation & Digital Transformation Teams",
                "Startups seeking investor confidence",
                "Investors evaluating portfolio opportunities",
              ].map((text, index) => (
                <div
                  key={index}
                  className="wow descripp animate__animated animate__fadeInUp d-flex align-items-center gap-3 right-text"
                  data-wow-delay={`${0.5 + index * 0.1}s`}
                >
                  <img
                    src="assets/icons/green-right.svg"
                    alt="Green check icon"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <span>{text}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            {/* <div
              className="new_section_button wow animate__animated animate__fadeInUp d-flex flex-column flex-sm-row"
              data-wow-delay="1s"

            >
              <button className="primary-button py-4 w-sm-auto text-uppercase">
                Learn more
              </button>
              <button className="secondary-button-2 py-4 w-sm-auto text-uppercase">
                Product tour
              </button>
            </div> */}
          </div>

          {/* Image */}
          <div
            className="WhoFors_new_image wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.3s"
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <img
              src="assets/images/WhoIt’For.png"
              alt="Who It's For"
              className="img-fluid"
              loading="lazy"
            />
          </div>

        </div>
        {/* </div> */}
      </section>

      {/* <!-- End Who It’s For --> */}

      {/* <!-- How It Works --> */}
      <section
        id="work"
        className="how_it_works_new_content bg-dark text-white position-relative wow animate__animated animate__fadeIn "
        // style={{
        //   backgroundImage: "url('assets/images/HowItWorks-bg.png')",
        //   backgroundSize: "cover",
        //   backgroundPosition: "center",
        //   marginTop: '120px'
        // }}
        data-wow-duration="1s"
      >
        <div className="how_it_works_new_content_container container_new px-4 "
        // style={{ margin: '100px auto' }}
        >
          {/* Section Header */}
          <div className="text-center">
            <span
              className=" how_it_works_pill d-inline-block text-sm   bg-white bg-opacity-25  wow animate__animated animate__fadeInDown"
              data-wow-delay="0.1s"
            >
              How It Works
            </span>
            <h6
              className=" how_it_works_heading  fw-semibold lh-tight wow animate__animated animate__fadeInUp"
              // style={{ paddingTop: 20, paddingBottom: 40 }}
              data-wow-delay="0.2s"
            >
              From Idea to Confidence in 3 Steps
            </h6>
          </div>

          {/* Steps */}
          <div class="steps_new d-flex flex-column flex-lg-row"
          // style={{ gap: 40 }}
          >
            {[
              {
                icon: "lightbulb.svg",
                title: "Sign up free.",
                subtitle: "No risk, no credit card.",
                delay: 0.3,
              },
              {
                icon: "target.svg",
                title: "Evaluate an initiative.",
                subtitle: "Use Paybacck’s tools on your current or past projects.",
                delay: 0.4,
              },
              {
                icon: "seal-check.svg",
                title: "Get your scores & roadmap.",
                subtitle: "See if the initiative is worth it—and know exactly what’s missing.",
                delay: 0.5,
              },
            ].map((step, index) => (
              <div className=" wow animate__animated animate__fadeInUp"
                data-wow-delay={`${step.delay}s`}
                style={{ backgroundColor: "rgb(47 46 133)", borderRadius: 24, flex: 1 }}
                key={index}>
                <div
                  className=" rounded-4 "
                  style={{ backgroundColor: "rgba(40, 39, 114, 0.8)}", padding: 24 }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle "
                    style={{ width: "48px", height: "48px", border: '1px solid #37B2F7' }}
                  >
                    <img src={`assets/icons/${step.icon}`} alt={step.title} />
                  </div>
                  <p className="step_box_title"
                  // style={{ fontSize: 20 }}
                  >{step.title}</p>
                  <p className="" style={{ lineHeight: "20px", fontSize: 14, fontWeight: 500 }}>{step.subtitle}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div
            className="d-flex flex-wrap justify-content-center gap-3 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.6s"
            style={{ marginTop: 35 }} // 30 48
          >
            <button
              onClick={() => navigate('/sign')}
              className="primary-button px-4 py-4 px-5 w-sm-auto text-uppercase d-flex align-items-center justify-content-center">
              Start My Free Trial
            </button>
          </div>
        </div>
      </section>

      {/* <!--End How It Works --> */}

    </div>
  );
}


